<template lang="pug">
.category-products.container.mx-auto.px-4.my-8(ref="container")
    .loading(v-if="loading")
        //- TODO: skeleton
        Spinner(:size="10" :thickness="2")
    .teasers(v-else-if="teasers && teasers.length")
        .top-row.flex(v-if="(teasers && teasers.length) || showFilters")
            .filters.flex-grow
              //- TODO
        .justified.paginated-teasers(v-if="activeOrientation === 'justified'" :style="{ height: `${layoutGeometry.containerHeight}px` }")
            Teaser(
                v-for="teaser in tiles"
                :key="teaser.id"
                v-if="teaser"
                :teaser="teaser"
                display="tile"
            )
        .horizontal.paginated-teasers.grid.grid-flow-row.auto-rows-max(v-else-if="activeOrientation === 'horizontal'")
            Teaser(
                v-for="teaser in teasers"
                :key="teaser.id"
                v-if="teaser"
                :teaser="teaser"
                display="card"
            )
        .vertical.paginated-teasers(v-else-if="activeOrientation === 'vertical'")
            pre VERTICAL
        Pagination.mt-5(
          v-if="pageInfo && pageInfo.lastPage > 1"
          :last-page="pageInfo.lastPage"
          :current-page="pageInfo.currentPage"
          nav-class="pagination is-rounded"
          @change="changePage"
        )
          span.icon(slot="prev")
            i.fas.fa-arrow-left
          span.icon(slot="next")
            i.fas.fa-arrow-right
            //- TODO
    .not-found(v-else)
        .notification Bisher gibt es hier noch keine Produkte.
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import justifiedLayout from "justified-layout";
// import Multiselect from 'vue-multiselect';
import router from "@/router";
import { get, debounce, cloneDeep } from "@/helpers";

import Teaser from "./Teaser";
import Pagination from "@/components/Pagination";

import TilesIcon from "@/assets/svgs/tiles-icon.svg";

export default {
  name: "ProductList",
  props: {
    section: {
      type: Object,
      required: true
    },
    perPage: {
      type: Number,
      default: 12
    },
    defaultOrientation: {
      type: String,
      default: "horizontal",
      validator: val => ["horizontal", "vertical", "justified"].includes(val)
    },
    forcedOrientation: {
      type: String,
      validator: val => ["horizontal", "vertical", "justified"].includes(val)
    }
  },
  data() {
    return {
      fetching: false,
      showFilters: false,
      loading: false,
      products: undefined,
      justifiedLayoutConfig: {
        containerWidth: undefined,
        containerPadding: {
          top: undefined,
          right: undefined,
          bottom: undefined,
          left: undefined
        },
        boxSpacing: {
          horizontal: 16,
          vertical: 70 + 16
        },
        targetRowHeight: 350
      }
    };
  },
  components: {
    Teaser,
    TilesIcon,
    Pagination
  },
  watch: {
    "$route.query"(query) {
      window.scrollTo(0, 0);
      this.currentPage = get(query, `P${this.section.id}`) || 1;
      this.refetch();
    }
  },
  computed: {
    s() {
      return this.sections.findIndex(el => el.id === this.section.id);
    },
    // loading() {
    //   return get(this.section, "teasers.loading", true);
    // },
    teasers() {
      let teasers = [];

      if (this.loading) {
        if (this.orientation === "horizontal")
          teasers = new Array(this.perPage);
        else teasers = new Array(1);
      } else {
        teasers = get(this.products, "items") || [];
      }

      teasers.forEach(teaser => {
        let media = get(teaser, "media");
        if (media && media.length) {
          media = media.find(el => get(el, "settings.show.list") === true);

          if (media && media.type) {
            teaser.media = media;
            switch (media.type) {
              case "image":
                if (media.image) {
                  teaser.ratio = media.image.width / media.image.height;
                } else teaser.ratio = 1;
                break;

              // TODO
              // handle videos and files
              case "video":
                teaser.ratio = 16 / 9;
                break;

              default:
                teaser.ratio = 1;
            }
          }
        } else {
          delete teaser.media;
          teaser.ratio = 1;
        }
      });

      return teasers;
    },
    filters() {
      return get(this.section, "teasers.pagination.filters") || [];
    },
    pageInfo() {
      return (
        get(this.products, "pageInfo") || {
          currentPage: 1,
          lastPage: 1,
          total: 0,
          perPage: this.perPage
        }
      );
    },
    layoutGeometry() {
      const ratios = this.teasers.map(el => el.ratio);
      return justifiedLayout(ratios, this.justifiedLayoutConfig);
    },
    tiles() {
      let tiles = [];
      this.teasers.forEach((teaser, i) => {
        const style = this.layoutGeometry.boxes[i];

        let tile = { ...teaser, ...{ style } };
        delete tile.ratio;

        tile.style.height += 70;

        tiles.push(tile);
      });
      return tiles;
    },
    settings() {
      return this.section.settings || [];
    },
    orientationOptions() {
      const setting = this.settings.find(el => el.key === "display-types");
      if (!setting || !setting.options || !setting.options.length)
        return ["card", "row", "tile"];
      else return setting.options.map(el => el.key);
    },
    activeOrientation() {
      if (this.forcedOrientation) return this.forcedOrientation;
      let orientation = this.defaultOrientation;

      switch (this.preferredOrientation) {
        case "horizontal":
          if (this.orientationOptions.includes("card"))
            orientation = this.preferredOrientation;
          break;

        case "vertical":
          if (this.orientationOptions.includes("row"))
            orientation = this.preferredOrientation;
          break;

        case "justified":
          if (this.orientationOptions.includes("tile"))
            orientation = this.preferredOrientation;
          break;
      }

      const orientations = {
        card: "horizontal",
        row: "vertical",
        tile: "justified"
      };
      return orientation || orientations[this.orientationOptions[0]];
    },
    ...mapGetters({
      cms: "CMS",
      sections: "sections",
      preferredOrientation: "shop/preferredListOrientation"
    })
  },
  methods: {
    changePage(currentPage) {
      if (this.$refs.teasers) {
        this.$refs.teasers.scrollIntoView({
          behavior: "smooth"
        });
      }

      if (currentPage > 1) {
        let query = {};
        query[`P${this.section.id}`] = currentPage;
        router.push({ query });
      } else {
        router.push({ query: null });
      }

      this.currentPage = currentPage;
      this.refetch();
    },
    refetch() {
      this.loading = true;

      const shop = get(this.cms, "shop.id");
      let categories = [];

      let c = undefined;
      if ((c = get(this.section, "shopCategories"))) {
        categories = c.map(category => category.id);
      }

      const payload = {
        pageInfo: {
          currentPage: parseInt(this.currentPage),
          perPage: parseInt(this.perPage)
        },
        filters: [
          {
            key: "shop",
            match: shop.toString()
          },
          {
            key: "status",
            match: "enabled"
          },
          {
            key: "categories",
            in: categories
          },
          {
            key: "qty_sum",
            from: 1
          }
        ],
        order: "date" // property:groupsort
      };
      this.fetchTeasers(payload)
        .then(response => {
          if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
            this.changePage(response.pageInfo.lastPage);
            return;
          }

          const products = cloneDeep(response);
          if (products.items && products.items.length) {
            products.items.forEach((product, i) => {
              product.position = i + 1;
            });
          }

          this.products = products;
          // this.insertProducts({ products });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    load(page = 1) {
      this.fetching = true;

      let pagination = get(this.section, "teasers.pagination");

      if (!pagination || !pagination.filters) {
        const categories = this.section.shopCategories.map(
          category => category.id
        );
        pagination = {
          filters: [
            {
              key: "categories",
              in: categories
            },
            {
              key: "shop",
              match: this.cms.shop.id
            },
            {
              key: "status",
              match: "enabled"
            },
            {
              key: "qty_sum",
              from: 1
            }
          ],
          pageInfo: {
            currentPage: 1,
            lastPage: 1,
            total: 0,
            perPage: this.perPage
          }
        };
      }

      pagination.pageInfo.currentPage = page;

      this.fetchTeasers(pagination)
        .then(({ filters, items, pageInfo }) => {
          const teasers = {
            loading: false,
            pagination: { filters, items, pageInfo }
          };
          this.insertTeasers({ s: this.s, teasers });
        })
        .finally(() => (this.fetching = false));
    },
    ...mapMutations({
      updateTeasersLoading: "updateTeasersLoading",
      insertTeasers: "insertTeasers",
      // addFilter: 'addFilter',
      // updateFilter: 'updateFilter',
      // insertPageInfo: 'insertPageInfo',
      setPreferredOrientation: "shop/setPreferredListOrientation"
    }),
    ...mapActions({
      fetchTeasers: "shop/fetchProductsPaginated"
    })
  },
  mounted() {
    const products = { loading: true, pagination: {} };
    this.products = products;
    // this.insertProducts({ products });

    this.currentPage = get(this.$route, `query.P${this.section.id}`) || 1;
    // this.currentPage = 1;
    this.refetch();

    // this.load();

    // if (this.orientation === 'justified') {
    const calculateDimansions = () => {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.justifiedLayoutConfig.containerWidth = this.$refs.container.offsetWidth;
        this.justifiedLayoutConfig.containerWidth -=
          parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

        this.justifiedLayoutConfig.containerPadding = {
          top: parseInt(style.paddingTop),
          right: 0,
          bottom: parseInt(style.paddingBottom) + 70,
          left: 0
        };
      }
    };

    window.addEventListener("resize", debounce(calculateDimansions, 100));
    calculateDimansions();
    // }
  }
};
</script>

<style lang="sass" scoped>
.loading > section
  min-height: 140px
.category-products
  display: flex
  flex-grow: 1
  .loading
    display: flex
    width: 100%
  .teasers
    width: 100%
  .paginated-teasers
    &.horizontal
      grid-template-columns: 1fr
      grid-gap: 1rem
      align-content: space-around
      justify-content: space-between
      @screen sm
        grid-template-columns: repeat(2, 300px)
      @screen lg
        grid-template-columns: repeat(3, 300px)
      @screen xl
        grid-template-columns: repeat(4, 300px)
    &.vertical
      // TODO
    &.justified
      position: relative
</style>
